import request from '@/utils/http'

const PREFIX = '/channel'

const file = {
  upload(formData) {
    return request(
      `${PREFIX}/upload`,
      'post',
      formData,
      { 'Content-Type': 'multipart/form-data' }
    )
  }
}

const businessChannel = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  show(id) {
    return request(
      `${PREFIX}/${id}`,
      'get'
    )
  },
  listByAppKey(appKey) {
    return request(
      `${PREFIX}/list/${appKey}`,
      'get'
    )
  },
  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  },

  delete(id) {
    return request(
      `${PREFIX}/${id}`,
      'delete'
    )
  }
}

export default {
  businessChannel,
  file
}

